// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".searchSuggestions-root-e-F {\n    position: relative;\n    width: 100%;\n}\n.searchSuggestions-results-oZF {\n    position: absolute;\n    width: 100%;\n    left: 0;\n    top: 54px;\n    background-color: white;\n    z-index: 110;\n    border: 1px solid #F2F2F2;\n    max-height: 202px;\n    overflow-y: scroll;\n}\n\n.searchSuggestions-loading-5Oj { }\n\n.searchSuggestions-suggestion-43c {\n    list-style-type: none;\n    cursor: pointer;\n    padding: 1rem;\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n}\n\n.searchSuggestions-suggestion-43c svg {\n    margin-right: 1rem;\n    min-width: 1.6rem;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "searchSuggestions-root-e-F",
	"results": "searchSuggestions-results-oZF",
	"loading": "searchSuggestions-loading-5Oj",
	"suggestion": "searchSuggestions-suggestion-43c"
};
export default ___CSS_LOADER_EXPORT___;
